(function () {
    //Service code here
    var dataService = function ($http, $window, $log, $q, $timeout, $rootScope, Constants, adalAuthenticationService) {

        var cacheConfigData = {};
        var shadowResponse = [];
        var validatedPages = [];
        var saveCounter = 0;
        var previousPage = null;
        var programOriginalResponse = [];
        var programRegisteredOriginalResponse = [];
        var navigationTabsResponse = [];
        var navigationTabsOriginalResponse = [];
        var orgNameResponse = [];
        var orgNameOriginalResponse = [];
        var cutOffDate = "";
        var isDHComplaint = false;
        var isDFFHComplaint = false;
        var isDHHSComplaint = false;

        var isAuthenticated = function () {
            if (window.location.hash.replace("#/", "") == "")
                return false;
            // identify department 
            if (['DH', 'DFFH'].includes(Constants.Url.landing))
                return !!adalAuthenticationService.userInfo && adalAuthenticationService.userInfo.isAuthenticated;
            else
                (window.location.hash.indexOf("access_token=") < 0) && window.location.reload();
        }

        var userFullName = function () {
            return adalAuthenticationService.userInfo &&
                adalAuthenticationService.userInfo.profile &&
                adalAuthenticationService.userInfo.profile.name;
        }

        var userName = function () {
            if (adalAuthenticationService.userInfo &&
                adalAuthenticationService.userInfo.profile &&
                adalAuthenticationService.userInfo.profile.upn) {
                return adalAuthenticationService.userInfo.profile.upn;
            }
            else {
                return null;
            }
        }

        var isSessionActive = function () {
            var isValidSession = true;
            var adalError = sessionStorage.getItem("adal.error");
            //check status AADSTS50058 which means that A silent sign -in request was sent but no user is signed in.
            var adalErrorDescription = sessionStorage.getItem("adal.error.description");
            if (adalErrorDescription.startsWith('AADSTS50058') || adalError != '') {
                isValidSession = false;
            }

            return isValidSession;
        }

        var isAdhocSubmissionUser = null;
        var adhocId = null;
        var isIncidentEditable = true;
        var manageIncidentState = Constants.ManageIncidentState.view;
        var selectedBulkIncidents = [];
        var miFilters = null;
        var mFFilters = null;
        var mcoFilters = null;
        var mcpFilters = null;
        var isFollowUpEditable = false;

        var maxTemplateVersions = {
            complaintTemplateVersion: 0,
            complaintRegisteredTemplateVersion: 0,
            feedbackAssessment: 0,
            feedbackAdditionalInfo: 0,
            feedbackInvestigate: 0,
            feedbackRespond: 0,
            feedbackPracticeImprovement: 0
        }

        var responseInfo = {
            access: null,
            incidentId: null,
            incidentRef: null,
            responses: {},
            template: null,
            versionNumber: null,
            lastUpdatedTime: null,
            status: null,
            statusText: null,
            programText: null,
            lodgementDate: null,
            reportedDate: null,
            submittedDate: null,
            role: null, // pipe-separated list of roles, e.g.: 'StaffMember|IncidentManager''
            captchaResponse: null,
            adhocSubmissionId: null,
            caseNotes: null,
            // adding more for fllowups
            //FollowUpType: null,
            incidentDate: null,
            ComplaintsFormType: null,
            ComplaintsFormData: null,
            roles: function () {
                return (this.role && this.role.split('|')) || [];
            },
            hasRole: function (roleToFind) {
                return this.roles().some(function (element) {
                    return element === roleToFind;
                });
            }
        };

        var isPartiallyRegisteredUser = function () {
            return isAuthenticated() && isNonBusinessUser();
        }

        var isFullyRegisteredUser = function () {
            return isAuthenticated() && isBusinessUser();
        }

        var isBusinessUser = function () {
            var roles = responseInfo.roles();
            return roles.length > 0 && roles.some(function (element) {
                return (element !== Constants.Role.FMS_Admin && element !== Constants.Role.Requestor);
            });
        };

        var isPublicUser = function () {
            var roles = responseInfo.roles();
            return roles.length == 1 && roles[0] == Constants.Role.Requestor;
        };

        var isNonBusinessUser = function () {
            var roles = responseInfo.roles();
            return roles.length > 0 && responseInfo.roles().every(function (element) {
                return (element === Constants.Role.FMS_Admin || element === Constants.Role.Requestor);
            });
        };

        var isFmsAdminUser = function () {
            return responseInfo.hasRole(Constants.Role.FMS_Admin);
        }

        var isRegisteredFmsAdminUser = function (userRoles) {
            return userRoles &&
                userRoles.length > 0 &&
                userRoles.some(function (element) {
                    return element === Constants.Role.FMS_Admin;
                });
        }

        var isRegisteredFmsLevel3User = function (userRoles) {
            return userRoles &&
                userRoles.length > 0 &&
                userRoles.some(function (element) {
                    return element === Constants.Role.FMS_Level3User;
                });
        }

        var isRegisteredPrivacyUser = function (userRoles) {
            return userRoles &&
                userRoles.length > 0 &&
                userRoles.some(function (element) {
                    return element === Constants.Role.PrivacyOfficer ||
                        element === Constants.Role.PrivacyManager ||
                        element === Constants.Role.IncidentManager ||
                        element === Constants.Role.Investigator;
                });
        }

        var isRegisteredComplaintsUser = function (userRoles) {
            return userRoles &&
                userRoles.length > 0 &&
                userRoles.some(function (element) {
                    return element === Constants.Role.ComplaintsManager ||
                        element === Constants.Role.ActionOfficer || element === Constants.Role.FMS_ComplaintsAdmin;
                });
        }

        // Used for saving and concurrency
        var saveQueueDeferred = $q.defer();
        saveQueueDeferred.resolve();
        var endOfSavePromiseChain = saveQueueDeferred.promise;

        // TODO: Enable the tracking code for Google Analytics below once CIMS key is available

        // Google analytics page visit
        var trackPageVisitWithGA = function (pageName) {
            (function (i, s, o, g, r, a, m) {
                i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
                    (i[r].q = i[r].q || []).push(arguments)
                }, i[r].l = 1 * new Date(); a = s.createElement(o),
                    m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
            })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
            ga('WOVGprofileNumber.send', 'pageview', (dept + "/" + site + document.location.pathname + document.location.search).toLowerCase());
            ga('DEPTprofileNumber.send', 'pageview', (site + document.location.pathname + document.location.search).toLowerCase());
            ga('SITEprofileNumber.send', 'pageview', (document.location.pathname + document.location.search + document.location.hash).toLowerCase());
        };

        // Google analytics event
        var trackEventsWithGA = function (category, action, label) {
            ga('SITEprofileNumber.send', 'event', {
                eventCategory: category,
                eventAction: action,
                eventLabel: label
            });
        };

        // this function gets the config data from the server for the specified template
        var getConfiguration = function (template, versionNumber, incidentId, useSecured) {

            var requestData = { template: template, versionNumber: versionNumber, incidentId: incidentId, directSubmission: this.isAdhocSubmissionUser, directSubmissionId: this.adhocId };

            //get the request url from the getConfigDataURL div in _Layout file
            //var baseUrl = $('#getConfigDataURL').data('request-url');
            var baseUrl = Constants.Url.getConfigDataURL;
            if (!useSecured)
                baseUrl = Constants.Url.getConfigDataPublicURL;

            var url = baseUrl;
            return $http({
                method: 'POST',
                url: url,
                data: angular.toJson(requestData),
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                this.configData = response.data.configData;
                this.configData[response.data.configData.template] = response.data.configData;
                return response.data;
            });
        }

        var getConfigurationUsingCache = function (template, versionNumber, incidentId, useSecured) {
            var logMessagePrefix = (new Date()).toString() +
                ': DataServices.getConfigurationUsingCache' +
                '(template = ' + template + ', versionNumber = ' + versionNumber + ', incidentId = ' + incidentId + ', useSecured = ' + useSecured + ') - ';
            console.log(logMessagePrefix + 'CALLING...');
            var deferred = $q.defer();
            var config = this.getCachedConfigData(template);
            if (versionNumber != null && config != null && config.versionNumber != versionNumber) {
                config = null;
            }
            if (config) {
                console.log(logMessagePrefix + 'SUCCESS (got result from client cache)');
                deferred.resolve(config);
            } else {
                console.log(logMessagePrefix + 'CACHE IS EMPTY: calling DataServices.getConfiguration');
                var that = this;
                this.getConfiguration(template, versionNumber, incidentId, useSecured)
                    .then(function (response) {
                        console.log(logMessagePrefix + 'SUCCESS (got result from server API call)');
                        that.pushConfigData(response.configData, template, response.versionNumber, response.role);
                        var config = that.getCachedConfigData(template);
                        deferred.resolve(config);
                    }, function (data) {
                        console.log(logMessagePrefix + 'FAILURE (data = "' + JSON.stringify(data) + '")');
                        deferred.reject(data);
                    });
            }
            return deferred.promise;
        }

        var getUserInfoData = function () {
            var baseUrl = Constants.Url.getUserProfileData;

            var url = baseUrl;
            return $http({
                method: 'POST',
                url: url,
                headers: { 'Content-Type': 'application/json' }
            });
        }

        var getUserProfileInfoUsingCache = function () {
            var deferred = $q.defer();

            var config = this.getUserInfoDataFromCache(this.userName());
            if (config) {
                deferred.resolve(config);
            }
            else {
                var that = this;
                this.getUserInfoData()
                    .then(function (response) {
                        that.pushUserInfoDataToCache(response.data);
                        var config = that.getUserInfoDataFromCache();
                        deferred.resolve(config);
                    }, function (data) {
                        deferred.reject(data);
                    });
            }

            return deferred.promise;
        }

        var getApplicationLastUpdateDate = function () {
            var url = Constants.Url.getApplicationLastUpdateDateURL;
            return $http({
                method: 'POST',
                url: url
            }).then(function (response) {
                return new Date(response.data.value);
            });
        }

        var getFeedbackAssignees = function (feedbackId, IsDHVisible) {
            return $http({
                method: 'POST',
                url: Constants.Url.getFeedbackAssigneesURL(feedbackId, IsDHVisible),
                headers: { 'Content-Type': 'application/json' }
            })
                .then(function (response) {
                    return response.data;
                });
        }

        var getFeedbacks = function (requestData) {
            return $http({
                method: 'POST',
                data: angular.toJson(requestData),
                url: Constants.Url.getFeedbacksURL,
                headers: { 'Content-Type': 'application/json' }
            })
                .then(function (response) {
                    return response.data;
                });
        }

        var getFeedbackById = function (feedbackId) {
            return $http({
                method: 'POST',
                url: Constants.Url.getFeedbackByIdURL(feedbackId),
                headers: { 'Content-Type': 'application/json' }
            })
                .then(function (response) {
                    return response.data;
                });
        }

        var getLinkableFeedbacks = function (feedbackId) {
            return $http({
                method: 'POST',
                url: Constants.Url.getLinkableFeedbacksURL(feedbackId),
                headers: { 'Content-Type': 'application/json' }
            })
                .then(function (response) {
                    return response.data;
                });
        }

        var saveFeedbackLink = function (requestData) {
            return $http({
                method: 'POST',
                data: angular.toJson(requestData),
                url: Constants.Url.saveFeedbackLinkURL,
                headers: { 'Content-Type': 'application/json' }
            })
                .then(function (response) {
                    return response.data;
                });
        }

        var removeFeedbackLink = function (requestData) {
            return $http({
                method: 'POST',
                data: angular.toJson(requestData),
                url: Constants.Url.removeFeedbackLinkURL,
                headers: { 'Content-Type': 'application/json' }
            })
                .then(function (response) {
                    return response.data;
                });
        }

        var assignFeedback = function (requestData) {
            return $http({
                method: 'POST',
                data: angular.toJson(requestData),
                url: Constants.Url.assignFeedbackURL,
                headers: { 'Content-Type': 'application/json' }
            })
                .then(function (response) {
                    return response.data;
                });
        }

        // this function deletes the document
        var deleteDocument = function (documentId) {
            var url = "";
            if (isAuthenticated()) {
                url = Constants.Url.getDeleteDocumentURL;
            } else {
                url = Constants.Url.getPublicDeleteDocumentURL;
            }

            return $http({
                method: 'POST',
                url: url,
                data: angular.toJson({ documentId: documentId }),
                headers: { 'Content-Type': 'application/json' }
            });
        }

        // this function allows to view the uploaded document
        var viewDocument = function (documentId) {
            var url = "";
            if (isAuthenticated()) {
                url = Constants.Url.getGetDocumentURL;
            } else {
                url = Constants.Url.getPublicGetDocumentURL;
            }

            return $http({
                method: 'POST',
                url: url,
                data: angular.toJson({ documentId: documentId }),
                headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer'
            });
        }

        var viewIncidentPdf = function (feedBackid) {

            return $http({
                method: 'POST',
                url: Constants.Url.getFeedbackPdf(feedBackid),
                headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer'
            });
        }

        var viewAllFormsPdf = function (feedBackid) {

            return $http({
                method: 'POST',
                url: Constants.Url.getAllFormsPdf(feedBackid),
                headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer'
            });
        }


        var viewComplaintsRegisteredPdf = function (feedBackid) {

            return $http({
                method: 'POST',
                url: Constants.Url.getComplaintsRegisteredPdf(feedBackid),
                headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer'
            });
        }

        var viewComplaintsUnRegisteredPdf = function (feedBackid) {
            var link = Constants.Url.getComplaintsUnRegisteredPdf(feedBackid);

            return $http({
                method: 'POST',
                url: link,
                headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer'
            });
        }


        var viewComplaintsAllFormsPdf = function (feedBackid) {

            return $http({
                method: 'POST',
                url: Constants.Url.getComplaintsAllFormsPdf(feedBackid),
                headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer'
            });
        }



        // Saves the client incident for registered users
        var saveIncidentRegisteredUser = function (feedbackType, isDHVisible, isAfterCutOffDate) {
            var url = Constants.Url.getSaveIncidentRegisteredUserURL;

            var requestData = {
                "Response": angular.toJson(responseInfo.responses),
                "Template": responseInfo.template,
                "FeedbackType": feedbackType,
                "TemplateVersion": JSON.stringify(responseInfo.versionNumber),
                "Ref": responseInfo.incidentRef,
                "Id": responseInfo.incidentId,
                "ModifiedDate": responseInfo.lastUpdatedTime,
                "statusText": responseInfo.statusText,
                "isDHVisible": isDHVisible,
                "isAfterCutOffDate": isAfterCutOffDate
            };

            return $http({
                method: 'POST',
                url: url,
                data: angular.toJson(requestData),
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                if (response && response.data && response.data.id) {
                    with (dataService) {
                        responseInfo.incidentId = response.data.id;
                        responseInfo.incidentRef = response.data.ref;
                        responseInfo.lastUpdatedTime = response.data.allocatedLastUpdatedTime
                    }

                    return response;
                }
            });
        }

        // Save incident in draft mode for document upload
        var saveIncidentForDocumentUpload = function (isDHVisible) {

            var url = "";
            if (isAuthenticated()) {
                url = Constants.Url.getSaveIncidentForDocumentUploadURL;
            } else {
                url = Constants.Url.getPublicSaveIncidentForDocumentUploadURL;
            }

            var requestData = {
                "Response": angular.toJson(responseInfo.responses),
                "Template": responseInfo.template,
                "TemplateVersion": JSON.stringify(responseInfo.versionNumber),
                "Ref": responseInfo.incidentRef,
                "Id": responseInfo.incidentId,
                "ModifiedDate": responseInfo.lastUpdatedTime,
                "statusText": responseInfo.statusText,
                "isDHVisible": isDHVisible
            }

            return $http({
                method: 'POST',
                url: url,
                data: angular.toJson(requestData),
                headers: { 'Content-Type': 'application/json' }
            }).then(
                function (response) {
                    if (response && response.data && response.data.id) {
                        responseInfo.incidentId = response.data.id;
                        responseInfo.incidentRef = response.data.ref;
                        responseInfo.lastUpdatedTime = response.data.allocatedLastUpdatedTime
                    }
                    return response;
                });
        }

        // Submit the client incident
        var submitIncident = function (feedbackType, isDHVisible, isAfterCutOffDate) {

            // different end points depending upon if requestred or not
            if (isAuthenticated()) {
                url = Constants.Url.getSubmitIncidentRegisteredUserURL;
            } else {
                url = Constants.Url.getSubmitIncidentURL;
            }

            var requestData = {
                "Response": angular.toJson(responseInfo.responses),
                "FeedbackType": feedbackType,
                "Template": responseInfo.template,
                "TemplateVersion": JSON.stringify(responseInfo.versionNumber),
                "Ref": responseInfo.incidentRef,
                "Id": responseInfo.incidentId,
                "ModifiedDate": responseInfo.lastUpdatedTime,
                "statusText": responseInfo.statusText,
                "isDHVisible": isDHVisible,
                "isAfterCutOffDate": isAfterCutOffDate
            }

            return $http({
                method: 'POST',
                url: url,
                data: angular.toJson(requestData),
                headers: { 'Content-Type': 'application/json' }
            }).then(
                function (response) {
                    // Ensure that incidentIds allocated as the result of a save are
                    // recorded correctly in client-side state.
                    with (dataService) {
                        if (response && response.data && response.data.id) {
                            responseInfo.incidentId = response.data.id;
                            responseInfo.incidentRef = response.data.ref;
                            responseInfo.lastUpdatedTime = response.data.allocatedLastUpdatedTime;
                        }
                    }
                    return response;
                });
        }

        // Returns the response and config for a specific follow up action.
        var getFollowUpResponseAndConfig = function (followUpId, feedbackTypeId) {
            var url = Constants.Url.getFollowUpResponseAndConfigURL;
            var requestData = {
                "id": followUpId,
                feedbackTypeId: feedbackTypeId
            };
            return $http({
                method: 'POST',
                url: url,
                data: angular.toJson(requestData),
                headers: { 'Content-Type': 'application/json' }
            });
        }

        var updateFeedbackStatus = function (feedbackType) {
            var url = Constants.Url.geUpdateFeedbackStatusUpURL;
            var requestData = {
                "Ref": responseInfo.incidentRef,
                "Id": responseInfo.incidentId,
                "FeedbackType": feedbackType,
                "ModifiedDate": responseInfo.lastUpdatedTime
            };

            return $http({
                method: 'POST',
                url: url,
                data: requestData,
                headers: { 'Content-Type': 'application/json' }
            });
        }

        var saveFollowUp = function (feedbackType) {
            var url = Constants.Url.getSaveFollowUpURL;
            var requestData = {
                "Id": responseInfo.followUpId,
                "FeedbackId": responseInfo.incidentId,
                "FeedbackType": feedbackType,
                "Response": angular.toJson(responseInfo.responses),
                "Template": responseInfo.template,
                "TemplateVersion": JSON.stringify(responseInfo.versionNumber),
                "FollowUpVersionNo": JSON.stringify(responseInfo.followUpVersionNumber),
                "ModifiedDate": responseInfo.lastUpdatedTime
            }

            return $http({
                method: 'POST',
                url: url,
                data: angular.toJson(requestData),
                headers: { 'Content-Type': 'application/json' }
            }).then(
                function (response) {
                    responseInfo.followUpId = response.data.id;
                    //update 
                    var deferred = $q.defer();
                    updateFeedbackStatus(feedbackType)
                        .finally(function () {
                            deferred.resolve(response); // we need the original response to be returned by the promise!
                        });
                    return deferred.promise;
                }
            );
        }

        var submitFollowUp = function (feedbackType) {
            var url = Constants.Url.getSubmitSubmitFollowUpURL;
            var requestData = {
                "Id": responseInfo.followUpId,
                "FeedbackId": responseInfo.incidentId,
                "FeedbackType": feedbackType,
                "Response": angular.toJson(responseInfo.responses),
                "Template": responseInfo.template,
                "TemplateVersion": JSON.stringify(responseInfo.versionNumber),
                "FollowUpVersionNo": JSON.stringify(responseInfo.followUpVersionNumber),
                "ModifiedDate": responseInfo.lastUpdatedTime
            }

            var httpPromise = $http({
                method: 'POST',
                url: url,
                data: angular.toJson(requestData),
                headers: { 'Content-Type': 'application/json' }
            });

            httpPromise.then(
                function (response) {
                    responseInfo.followUpId = response.data.id;
                    //update 
                    var deferred = $q.defer();
                    updateFeedbackStatus(feedbackType)
                        .finally(function () {
                            deferred.resolve(response); // we need the original response to be returned by the promise!
                        });
                    return deferred.promise;
                }
            );

            return httpPromise;
        }

        // Returns a summary of all the followup actions for an incident.
        var getFollowUpSummaryResponseAndConfig = function (feedbackTypeId, coordinationType) {
            var url = Constants.Url.getFollowUpSummaryResponseAndConfigURL;

            var requestData = {
                "id": responseInfo.incidentId,
                feedbackTypeId: feedbackTypeId,
                "FormConfigurationTemplateOptions": coordinationType
            };
            return $http({
                method: 'POST',
                url: url,
                data: angular.toJson(requestData),
                headers: { 'Content-Type': 'application/json' }
            });
        }

        var saveFeedbackCaseNotes = function () {
            var url = Constants.Url.getSaveFeedbackCaseNotesURL;

            var requestData = {
                "Response": angular.toJson(responseInfo.responses),
                "FeedbackId": responseInfo.incidentId
            };

            return $http({
                method: 'POST',
                url: url,
                data: angular.toJson(requestData),
                headers: { 'Content-Type': 'application/json' }
            });
        }

        // Sets the incident status to withdrawn for the supplied incident Id
        var withdrawFeedback = function (incidentId, withdrawReason, lastUpdatedTime) {
            var url = Constants.Url.getWithdrawFeedbackURL;
            var data = {
                FeedbackId: incidentId,
                WithdrawalReason: withdrawReason,
                LastUpdatedTime: lastUpdatedTime ? lastUpdatedTime : responseInfo.lastUpdatedTime
            };
            return $http({
                method: 'POST',
                url: url,
                data: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' }
            });
        }


        var getFeedbackHistory = function (historyType) {

            var url = Constants.Url.getFeedbackHistoryURL;
            var data = {
                FeedbackId: responseInfo.feedbackId,
                RetrieveType: historyType
            };

            return $http({
                method: 'POST',
                url: url,
                data: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' }
            });
        }

        var getComplainsFeedbackUnRegistered = function (feedBackid) {
            return $http({
                method: 'POST',
                url: Constants.Url.getComplaintsFeedbackUnRegistered(feedBackid),
                headers: { 'Content-Type': 'application/json' }
            });
        }

        // this function validates the date
        var validDateCheck = function (dateVal, minYear) {
            var dateMoment = moment(dateVal, 'YYYY-MM-DD', true);
            return (dateMoment.isValid() && dateMoment.isSameOrAfter(minYear + '-01-01'));
        }

        // resets the responseInfo object
        var resetResponseInfo = function () {
            responseInfo.access = null;
            responseInfo.incidentId = null;
            responseInfo.incidentRef = null;
            responseInfo.feedbackId = null;
            responseInfo.ref = null;
            responseInfo.incidentDate = null;
            responseInfo.responses = null;
            responseInfo.versionNumber = null;
            responseInfo.lastUpdatedTime = null;
            responseInfo.status = null;
            responseInfo.statusText = null;
            responseInfo.programText = null;
            responseInfo.lodgementDate = null;
            responseInfo.reportedDate = null;
            responseInfo.submittedDate = null;
            responseInfo.role = null;
            responseInfo.captchaResponse = null;
            responseInfo.userId = null;
            responseInfo.adhocSubmissionId = null;
            responseInfo.createdBy = null;

        }

        // Determines which pages are considered validated by looking at the pages in the response
        var determineValidatedPages = function (response) {
            var responseJsonObj = angular.fromJson(response);

            var validatedPages = [];
            for (var key in responseJsonObj) {
                validatedPages.push(key);
            }

            return validatedPages;
        }

        // retrieves config data from cache
        var getCachedConfigData = function (template) {
            var config = this.cacheConfigData[template];
            if (config) {
                this.configData = config.configData;
                this.configData[template] = config.configData;
                this.responseInfo.template = config.template;
                this.responseInfo.versionNumber = config.versionNumber;
                this.responseInfo.role = config.role;
                return this.cacheConfigData[template];
            }
            return null;
        }

        // Push config data in to cache
        var pushConfigData = function (configData, template, versionNumber, role) {
            this.configData = configData;
            this.configData[template] = configData;
            this.responseInfo.template = template;
            this.responseInfo.versionNumber = versionNumber;
            this.responseInfo.role = role;

            // Overwrite if config already exists, otherwise this will add.
            this.cacheConfigData[template] = {
                configData: configData,
                versionNumber: versionNumber,
                role: role,
                template: template
            }
        }

        var getUserInfoDataFromCache = function () {
            if (this.userName()) {
                var config = this.cacheConfigData[userName()];
                if (config) {
                    return this.cacheConfigData[userName()];
                }
            }

            return null;
        }

        // Push config data in to cache
        var pushUserInfoDataToCache = function (data) {
            if (this.userName()) {
                this.cacheConfigData[userName()] = data;
            }
        }

        var navigateToAdminFmsSite = function () {
            if (window.location.href.indexOf("DH") > -1) {
                window.location.href = __env.fmsAdminAppBaseUrl + '#/DH';
            }
            else {
                window.location.href = __env.fmsAdminAppBaseUrl + '#/DFFH';
            }
        }

        var getDocumentTemplates = function () {
            return $http({
                method: 'POST',
                url: Constants.Url.getGetDocumentTemplatesURL,
                headers: { 'Content-Type': 'application/json' }
            })
                .then(function (response) {
                    return response.data;
                });
        }

        var getDocumentTemplateFile = function (documentTemplateId) {
            return $http({
                method: 'GET',
                url: Constants.Url.getGetDocumentTemplateFileURL(documentTemplateId),
                headers: { 'Content-Type': 'application/json' },
                responseType: 'arraybuffer'
            })
                .then(function (response) {
                    return response.data;
                });
        }


        var reOpenFeedback = function (feedbackId, lastUpdatedTime) {
            var url = Constants.Url.getReOpenFeedbackURL;
            var data = {
                FeedbackId: feedbackId,
                LastUpdatedTime: lastUpdatedTime ? lastUpdatedTime : responseInfo.lastUpdatedTime
            };
            return $http({
                method: 'POST',
                url: url,
                data: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' }
            });
        }

        var deleteFeedback = function (feedbackId, lastUpdatedTime) {
            var url = Constants.Url.deleteFeedbackURL;
            var data = {
                FeedbackId: feedbackId,
                LastUpdatedTime: lastUpdatedTime ? lastUpdatedTime : responseInfo.lastUpdatedTime
            };
            return $http({
                method: 'DELETE',
                url: url,
                data: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' }
            });
        }

        var setAnonymousDetails = function (complainantDetails, isAnonymous) {
            if (complainantDetails !== undefined && complainantDetails !== null) {
                //Firstname, Lastname
                complainantDetails["rDFirstName"] = isAnonymous ? "Anonymous" : "";
                complainantDetails["rDLastName"] = isAnonymous ? "Anonymous" : "";

                //DOB fields
                complainantDetails["rDDOB"] = isAnonymous ? "1900-01-01" : "";
                complainantDetails["rDDOB-day"] = isAnonymous ? "01" : "";
                complainantDetails["rDDOB-month"] = isAnonymous ? "01" : "";
                complainantDetails["rDDOB-year"] = isAnonymous ? "1900" : "";

                //address fields
                if (isAnonymous) {
                    complainantDetails["rDAddress"] = "50 Lonsdale Street, Melbourne VIC, Australia";
                    complainantDetails["rDAddress-autoPostCode"] = "3000";
                    complainantDetails["rDAddress-autoState"] = "Victoria";
                    complainantDetails["rDAddress-autoStreetNumberName"] = "50 Lonsdale Street";
                    complainantDetails["rDAddress-autoSuburb"] = "Melbourne";
                    complainantDetails["rDAddress-lga"] = "Local Council";
                    complainantDetails["rDAddress-stateCode"] = "VIC";
                    complainantDetails["rDAddress-valid"] = true;
                }
            }
            return complainantDetails;
        }

        var getLocalCouncilDetailsFromAddress = function (stateCode, lga) {
            if (stateCode !== undefined) {
                var localCouncilDetails = undefined;
                if (stateCode === "VIC") {
                    localCouncilDetails = getLocalCouncilDetails(lga);
                    if (localCouncilDetails !== undefined) {
                        return { code: localCouncilDetails.code, text: localCouncilDetails.text };
                    }
                    else {
                        localCouncilDetails = getLocalCouncilDetails("Local Council");
                        return { code: localCouncilDetails.code, text: localCouncilDetails.text };
                    }
                } else {
                    if (stateCode === "Local Council") {
                        localCouncilDetails = getLocalCouncilDetails("Local Council");
                    }
                    else {

                        localCouncilDetails = getLocalCouncilDetails("Interstate");
                    }
                    return { code: localCouncilDetails.code, text: localCouncilDetails.text };
                }
            }
            else {
                return { code: undefined, text: '' };
            }
        }

        function getLocalCouncilDetails(localCouncil) {
            //Getting the config data for templates 7(UnRegistered) and 11(Registered) 
            var config = cacheConfigData[7] || cacheConfigData[11];
            var matchedLga = config.configData.optionSets
                .localgovernmentarea
                .filter(function (item) { return item.text === localCouncil; });
            if (matchedLga.length > 0) {
                return matchedLga[0];
            }
        }

        var extractCsv = function (dateRangeId, feedbackType, isDOH) {
            return $http({
                method: 'POST',
                url: Constants.Url.getCsvExtractUrl,
                data: JSON.stringify({ "dateRangeId": dateRangeId, 'feedbackTypeId': feedbackType, 'isDOH': isDOH }),
                headers: { 'Content-Type': 'application/json', 'Accept': 'text/csv' }
            });
        }

        var toggleFeedbackSensitivity = function (feedbackId, isSensitive, lastUpdatedTime) {
            var url = Constants.Url.toggleFeedbackSensitivityURL;
            var data = {
                FeedbackId: feedbackId,
                IsSensitive: isSensitive,
                LastUpdatedTime: lastUpdatedTime ? lastUpdatedTime : responseInfo.lastUpdatedTime
            };
            return $http({
                method: 'POST',
                url: url,
                data: JSON.stringify(data),
                headers: { 'Content-Type': 'application/json' }
            });
        }

        return {
            getLocalCouncilFromAddress: getLocalCouncilDetailsFromAddress,
            getConfiguration: getConfiguration,
            getUserInfoData: getUserInfoData,
            getUserProfileInfoUsingCache: getUserProfileInfoUsingCache,
            getConfigurationUsingCache: getConfigurationUsingCache,
            getApplicationLastUpdateDate: getApplicationLastUpdateDate,
            configData: null,
            locationData: null,
            sessionId: null,
            documentTypes: null,
            getFeedbackAssignees: getFeedbackAssignees,
            getFeedbacks: getFeedbacks,
            getFeedbackById: getFeedbackById,
            assignFeedback: assignFeedback,
            getLinkableFeedbacks: getLinkableFeedbacks,
            saveFeedbackLink: saveFeedbackLink,
            removeFeedbackLink: removeFeedbackLink,
            deleteDocument: deleteDocument,
            viewDocument: viewDocument,
            validationErrors: [],
            validatedPages: validatedPages,
            saveIncidentForDocumentUpload: saveIncidentForDocumentUpload,
            submitIncident: submitIncident,
            trackPageVisitWithGA: trackPageVisitWithGA,
            trackEventsWithGA: trackEventsWithGA,
            responseInfo: responseInfo,
            maxTemplateVersions: maxTemplateVersions,
            canAccessConfirmation: false,
            canAccessConsent: false,
            shadowResponse: shadowResponse,
            programOriginalResponse: programOriginalResponse,
            programRegisteredOriginalResponse: programRegisteredOriginalResponse,
            navigationTabsResponse: navigationTabsResponse,
            navigationTabsOriginalResponse: navigationTabsOriginalResponse,
            orgNameResponse: orgNameResponse,
            orgNameOriginalResponse: orgNameOriginalResponse,
            cutOffDate: cutOffDate,
            cacheConfigData: cacheConfigData,
            incidentSubmitted: false,
            determineValidatedPages: determineValidatedPages,
            previousPage: previousPage,
            getCachedConfigData: getCachedConfigData,
            pushConfigData: pushConfigData,
            getUserInfoDataFromCache: getUserInfoDataFromCache,
            pushUserInfoDataToCache: pushUserInfoDataToCache,
            saveIncidentRegisteredUser: saveIncidentRegisteredUser,
            isAuthenticated: isAuthenticated,
            userFullName: userFullName,
            userName: userName,
            isSessionActive: isSessionActive,
            isPartiallyRegisteredUser: isPartiallyRegisteredUser,
            isFullyRegisteredUser: isFullyRegisteredUser,
            isBusinessUser: isBusinessUser,
            isPublicUser: isPublicUser,
            isNonBusinessUser: isNonBusinessUser,
            isFmsAdminUser: isFmsAdminUser,
            isRegisteredFmsAdminUser: isRegisteredFmsAdminUser,
            isRegisteredFmsLevel3User: isRegisteredFmsLevel3User,
            isRegisteredPrivacyUser: isRegisteredPrivacyUser,
            isRegisteredComplaintsUser: isRegisteredComplaintsUser,
            withdrawFeedback: withdrawFeedback,
            isAdhocSubmissionUser: isAdhocSubmissionUser,
            adhocId: adhocId,
            isIncidentEditable: isIncidentEditable,
            manageIncidentState: manageIncidentState,
            selectedBulkIncidents: selectedBulkIncidents,
            miFilters: miFilters,
            mFFilters: mFFilters,
            mcoFilters: mcoFilters,
            mcpFilters: mcpFilters,
            resetResponseInfo: resetResponseInfo,
            getFollowUpSummaryResponseAndConfig: getFollowUpSummaryResponseAndConfig,
            saveFeedbackCaseNotes: saveFeedbackCaseNotes,
            getFollowUpResponseAndConfig: getFollowUpResponseAndConfig,
            submitFollowUp: submitFollowUp,
            saveFollowUp: saveFollowUp,
            viewIncidentPdf: viewIncidentPdf,
            viewAllFormsPdf: viewAllFormsPdf,
            viewComplaintsRegisteredPdf: viewComplaintsRegisteredPdf,
            viewComplaintsUnRegisteredPdf: viewComplaintsUnRegisteredPdf,
            viewComplaintsAllFormsPdf: viewComplaintsAllFormsPdf,
            navigateToAdminFmsSite: navigateToAdminFmsSite,
            getFeedbackHistory: getFeedbackHistory,
            getComplainsFeedbackUnRegistered: getComplainsFeedbackUnRegistered,
            getDocumentTemplates: getDocumentTemplates,
            getDocumentTemplateFile: getDocumentTemplateFile,
            reOpenFeedback: reOpenFeedback,
            deleteFeedback: deleteFeedback,
            setAnonymousDetails: setAnonymousDetails,
            extractCsv: extractCsv,
            toggleFeedbackSensitivity: toggleFeedbackSensitivity
        };
    };

    //Get the formApp module
    var formApp = angular.module('formApp');
    //Register this service with the formApp module
    formApp.factory('DataServices', ['$http', '$window', '$log', '$q', '$timeout', '$rootScope', 'Constants', 'adalAuthenticationService', dataService]);
}());